import { render, staticRenderFns } from "./PrestationType.vue?vue&type=template&id=d0810110"
import script from "./PrestationType.vue?vue&type=script&lang=js"
export * from "./PrestationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports